import { render } from "./kalio-office-hour-offering.vue?vue&type=template&id=7d17167e"
import script from "./kalio-office-hour-offering.vue?vue&type=script&lang=js"
export * from "./kalio-office-hour-offering.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__